import { computed, inject, Injectable, signal } from '@angular/core';
import { Observable, shareReplay, tap } from 'rxjs';
import { UserCreditsData, UserCreditsService } from './user-credits.service';

@Injectable({ providedIn: 'root' })
export class UserCreditsStateService {
    private creditsService = inject(UserCreditsService);

    private _credits = signal<UserCreditsData | null>(null);
    private creditsCache$?: Observable<any>;

    public readonly credits = this._credits.asReadonly();
    public readonly askRemaining = computed(() => this._credits()?.ask.remaining ?? 0);
    public readonly agentRemaining = computed(() => this._credits()?.agent.remaining ?? 0);
    public readonly askConsumedPct = computed(() => this.consumedPct(this._credits()?.ask ?? null));
    public readonly agentConsumedPct = computed(() => this.consumedPct(this._credits()?.agent ?? null));

    public consumedPct(entry: { consumed: number; allocated: number } | null): number | null {
        if (!entry || entry.allocated === 0) return null;
        return Math.round((entry.consumed / entry.allocated) * 100);
    }

    public fetchCredits(): Observable<any> {
        if (this.creditsCache$) {
            return this.creditsCache$;
        }

        this.creditsCache$ = this.creditsService.getCurrentCredits().pipe(
            tap((res) => {
                if (res.success && res.data) {
                    this._credits.set(res.data);
                }
            }),
            shareReplay(1)
        );

        return this.creditsCache$;
    }

    public refreshCredits(): Observable<any> {
        this.creditsCache$ = undefined;
        return this.fetchCredits();
    }

    public clearCredits(): void {
        this._credits.set(null);
        this.creditsCache$ = undefined;
    }
}
